import { useSelector } from 'react-redux';

import { State } from '../main/store';

export default function useAuthenticationMethod(): string | undefined {
  const selector = (state: State): string | undefined =>
    state.entities.authenticationMethod;
  return useSelector(selector);
}
